/**
 * TanStack Query hooks for `network-api-integrations`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	networkApiIntegrationsQueryKeys,
	type CreateNetworkApiIntegrationsBody,
	type ListNetworkApiIntegrationsResponse,
	type NetworkApiIntegrationsRow,
} from "./api";

export function useNetworkApiIntegrationsList(): UseQueryResult<ListNetworkApiIntegrationsResponse, Error> {
	return useQuery({
		queryKey: networkApiIntegrationsQueryKeys.list(),
		queryFn: list,
	});
}

export function useNetworkApiIntegrationsCreate(): UseMutationResult<NetworkApiIntegrationsRow, Error, CreateNetworkApiIntegrationsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: networkApiIntegrationsQueryKeys.all });
		},
	});
}

export function useNetworkApiIntegrationsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: networkApiIntegrationsQueryKeys.all });
		},
	});
}
